import {
  GET_SERVICES,
  UPDATE_SERVICE_HISTORY_INFO,
  UPDATE_PROMOTION_PARTICULARS_INFO,
  UPDATE_OTHER_SERVICES_INFO,
  DELETE_SERVICE_HISTORY_INFO,
  DELETE_PROMOTION_PARTICULARS_INFO,
  DELETE_OTHER_SERVICES_INFO,
} from "./types";
import {
  OtherServiceType,
  PromotionParticularType,
  ServicesHistoryType,
  ServicesType,
} from "@type/HRM/services";

export const getServicesRequest = (data: number | null) => {
  return {
    type: GET_SERVICES.GET_SERVICES_REQUEST,
    payload: { data },
  } as const;
};

export const getServicesSuccess = (data: ServicesType) => {
  return {
    type: GET_SERVICES.GET_SERVICES_SUCCESS,
    payload: { data },
  } as const;
};

export const getServicesFailed = () => {
  return {
    type: GET_SERVICES.GET_SERVICES_FAILED,
  } as const;
};

export const updateServicesHistoryRequest = (data: ServicesHistoryType) => {
  return {
    type: UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateServicesHistorySuccess = (data: ServicesHistoryType) => {
  return {
    type: UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateServicesHistoryFailed = () => {
  return {
    type: UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_FAILED,
  } as const;
};

export const updatePromotionParticularsInfoRequest = (
  data: PromotionParticularType
) => {
  return {
    type:
      UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updatePromotionParticularsInfoSuccess = (
  data: PromotionParticularType
) => {
  return {
    type:
      UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updatePromotionParticularsInfoFailed = () => {
  return {
    type:
      UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_FAILED,
  } as const;
};

export const updateOtherServicesInfoRequest = (data: OtherServiceType) => {
  return {
    type: UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateOtherServicesInfoSuccess = (data: OtherServiceType) => {
  return {
    type: UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateOtherServicesInfoFailed = () => {
  return {
    type: UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_FAILED,
  } as const;
};

export const deleteServicesHistoryInfoRequest = (data: {
  employeeID: number | null;
  servicesHistoryID: number;
}) => {
  return {
    type: DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteServicesHistoryInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteServicesHistoryInfoFailed = () => {
  return {
    type: DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_FAILED,
  } as const;
};

export const deletePromotionParticularsInfoRequest = (data: {
  employeeID: number | null;
  promotionParticularID: number;
}) => {
  return {
    type:
      DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deletePromotionParticularsInfoSuccess = (data: { id: number }) => {
  return {
    type:
      DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deletePromotionParticularsInfoFailed = () => {
  return {
    type:
      DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_FAILED,
  } as const;
};

export const deleteOtherServicesInfoRequest = (data: {
  employeeID: number | null;
  otherServiceID: number;
}) => {
  return {
    type: DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteOtherServicesInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteOtherServicesInfoFailed = () => {
  return {
    type: DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_FAILED,
  } as const;
};

export type ServicesActions =
  | ReturnType<typeof getServicesRequest>
  | ReturnType<typeof getServicesSuccess>
  | ReturnType<typeof getServicesFailed>
  | ReturnType<typeof updateOtherServicesInfoRequest>
  | ReturnType<typeof updateOtherServicesInfoSuccess>
  | ReturnType<typeof updateOtherServicesInfoFailed>
  | ReturnType<typeof deleteOtherServicesInfoRequest>
  | ReturnType<typeof deleteOtherServicesInfoSuccess>
  | ReturnType<typeof deleteOtherServicesInfoFailed>
  | ReturnType<typeof updatePromotionParticularsInfoRequest>
  | ReturnType<typeof updatePromotionParticularsInfoSuccess>
  | ReturnType<typeof updatePromotionParticularsInfoFailed>
  | ReturnType<typeof deletePromotionParticularsInfoRequest>
  | ReturnType<typeof deletePromotionParticularsInfoSuccess>
  | ReturnType<typeof deletePromotionParticularsInfoFailed>
  | ReturnType<typeof updateServicesHistoryRequest>
  | ReturnType<typeof updateServicesHistorySuccess>
  | ReturnType<typeof updateServicesHistoryFailed>
  | ReturnType<typeof deleteServicesHistoryInfoRequest>
  | ReturnType<typeof deleteServicesHistoryInfoSuccess>
  | ReturnType<typeof deleteServicesHistoryInfoFailed>;
